import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PayrollSetupList } from './PayrollSetupList'
import {
  GEP_ENROLL_PATHS,
  ONBOARDING_STEPS,
  useUpdatePayrollOnboardingStep,
} from '../helpers'
import { Button, Card, Checkbox, Link, Separator, Image, Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'

export const PayrollOverview = () => {
  const navigate = useNavigate()
  const [isChecked, setIsChecked] = useState(false)
  useUpdatePayrollOnboardingStep(ONBOARDING_STEPS.terms)

  return (
    <div>
      <Card>
        <div className="flex flex-col gap-6">
          <Text variant={TypographyStyles.H1}>Welcome to Heard Payroll</Text>

          <Separator />

          <div className="flex flex-col lg:flex-row gap-6">
            <div className="lg:w-1/2">
              <Text variant={TypographyStyles.H2}>
                Let’s set up your business
              </Text>
              <PayrollSetupList isIntro />
            </div>
            <div className="lg:w-7/12">
              <Image
                src="https://heard-images.s3.us-west-1.amazonaws.com/assets/payroll_homepage.png"
                alt="Payroll Overview"
              />
            </div>
          </div>

          <Text color={TextColors.MUTED}>
            <i>
              <b>Please note:</b> we are required to register your business with
              the state, meaning this process may take up to 1–2 business days
              to wait for approval. You will not be able to run payroll until
              you have received approval from the state.
            </i>
          </Text>

          <div className="w-full max-w-xs mt-6">
            <Button
              onClick={() => navigate(GEP_ENROLL_PATHS.company)}
              disabled={!isChecked}
              className="w-full"
            >
              Get Started
            </Button>
          </div>

          <Checkbox
            checked={isChecked}
            onCheckedChange={setIsChecked}
            label={
              <Text>
                <b>
                  By clicking the above button, I agree to all terms as provided
                  in Gusto&apos;s{' '}
                  <Link
                    href="https://gusto.com/about/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </Link>{' '}
                  and{' '}
                  <Link
                    href="https://flows.gusto.com/terms"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms of Service.
                  </Link>
                </b>
              </Text>
            }
          />
        </div>
      </Card>
    </div>
  )
}
